<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
      }"
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="height"
      size="small"
      resizable
      border
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:defaultImageUrl="{ row }">
        <el-image
          :src="
            row.defaultImageUrl
              ? row.defaultImageUrl
              : '/image/static/img/nopic.jpg'
          "
          style="width:80px; height:40px"
        >
          <!-- $osscdn(row.defaultImageCode) -->
          <div slot="error" class="image-slot">
            <img
              src="/image/static/img/nopic.jpg"
              style="width:80px; height:40px"
            />
          </div>
        </el-image>
      </template>
      <template v-slot:metadataDesc="{ row }">
        <div>{{ row.fabricWidth }}/{{ row.fabricWeight }}</div>
      </template>
      <template v-slot:expandContent="{ row }">
        <CuttingInfoGoods
          class="m-2"
          :orderCode="row.orderCode"
          :techCuttingCode="row.techCuttingCode"
          :techCuttingDetailCode="row.techCuttingDetailCode"
          :disabled="disabled"
        />
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            v-if="!disabled"
            :content="$l('INDEX.btn_tips_del') || '删除'"
            placement="top"
          >
            <i
              class="el-icon-delete tool-btn"
              @click="del(row.techCuttingDetailCode)"
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            v-if="!disabled"
            :content="'设置图片'"
            placement="top"
          >
            <i
              class="el-icon-picture-outline tool-btn"
              @click="setPicture(row)"
            ></i>
          </el-tooltip>
        </div>
      </template>

      <template v-slot:empty> </template>
    </vxe-grid>

    <el-dialog
      v-if="setImageDialogOptions.disabled"
      show-close
      :visible.sync="setImageDialogOptions.disabled"
      width="60%"
      :title="setImageDialogOptions.title"
      :close-on-click-modal="false"
      :before-close="() => close()"
      destroy-on-close
      append-to-body
    >
      <ImageDataDialog
        :techCuttingDetailCode="setImageDialogOptions.techCuttingDetailCode"
        :techCuttingCode="setImageDialogOptions.techCuttingCode"
        :orderCode="setImageDialogOptions.orderCode"
        :disabled="setImageDialogOptions.disabled"
      />
    </el-dialog>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import ImageDataDialog from './components/image-data'
import CuttingInfoGoods from '../cutting-info-goods'

export default {
  components: {
    ImageDataDialog,
    CuttingInfoGoods,
  },
  mixins: [TableAutoHeight],
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    tablePage: {
      type: Object,
      default: () => {},
    },
    loading: {
      default: false,
    },
    disabled: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      setImageDialogOptions: {
        disabled: false,
        orderCode: '',
        techCuttingCode: '',
        techCuttingDetailCode: '',
        title: '',
      },
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.$emit('reload'),
        },
        zoom: true,
      },
      tableColumns: [
        {
          field: 'seq',
          width: 50,
          align: 'center',
          type: 'seq',
        },
        {
          field: 'col-opt',
          title: this.$l('INDEX.table_label_operation') || '操作',
          headerAlign: 'center',
          align: 'center',
          width: 120,
          slots: {
            default: 'opt',
          },
        },
        {
          type: 'expand',
          width: 70,
          align: 'center',
          title: this.$l('INDEX.form_label_expand') || '展开',
          slots: {
            content: 'expandContent',
          },
        },
        {
          field: 'defaultImageUrl',
          width: 120,
          title: this.$l('INDEX.table_label_image') || '图片',
          align: 'center',
          slots: { default: 'defaultImageUrl' },
        },
        {
          title: '规格名称',
          field: 'groupSpecName',
          headerAlign: 'center',
          align: 'center',
          width: 100,
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title: '产品颜色',
          field: 'orderGoodsColor',
          headerAlign: 'center',
          align: 'center',
          width: 150,
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title: '面料位置',
          field: 'fabricPositionName',
          headerAlign: 'center',
          align: 'center',
          width: 100,
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title: '面料编号',
          field: 'fabricNo',
          headerAlign: 'center',
          align: 'center',
          width: 120,
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title: '面料显示名称',
          field: 'fabricDisplayName',
          headerAlign: 'center',
          align: 'left',
          minWidth: 300,
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title: '面料克重',
          field: 'fabricWeight',
          headerAlign: 'center',
          align: 'center',
          width: 100,
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title: '面料单位',
          field: 'fabricUnit',
          headerAlign: 'center',
          align: 'center',
          width: 100,
          showHeaderOverflow: true,
          showOverflow: true,
        },
      ],
    }
  },
  computed: {
    height() {
      return this.tableHeight - 8 < 500 ? 500 : this.tableHeight - 8
    },
  },
  methods: {
    setPicture(row) {
      this.setImageDialogOptions = {
        disabled: true,
        title: '设置默认图片',
        orderCode: row.orderCode,
        techCuttingCode: row.techCuttingCode,
        techCuttingDetailCode: row.techCuttingDetailCode,
      }
    },
    close() {
      this.setImageDialogOptions.disabled = false
      this.$emit('reload')
    },
    del(techCuttingDetailCode) {
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => {
          this.$api
            .techCuttingInfoDetailDelApi({ techCuttingDetailCode })
            .then(() => {
              this.$message({
                showClose: true,
                message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
                type: 'success',
              })

              this.$emit('reload')
            })
        })
        .catch(() => {})
    },
  },
}
</script>
